import RecruitmentActivityOverviewCard from 'routes/Analytics/RecruitmentActivityOverviewCard/RecruitmentActivityOverviewCard';

export default RecruitmentActivityOverviewCard;
